/** Phase E-3: ManageTab, BusinessManageForm, profile guide, departure groups, staff/insurance panels, manifest */

const manageForm = {
  saveFail: ['저장 실패', 'Could not save', 'Không lưu được', 'Не удалось сохранить'],
  categoryChangePending: [
    '카테고리 변경은 운영팀 확인 후 반영돼요. (보통 1-2일)',
    'Category change will be reviewed by our team (usually 1–2 days).',
    'Đổi ngành sẽ được đội vận hành duyệt (thường 1–2 ngày).',
    'Смена категории проверяется командой (обычно 1–2 дня).',
  ],
  saved: ['저장했어요', 'Saved', 'Đã lưu', 'Сохранено'],
  backToHub: ['관리 홈으로', 'Back to manage', 'Về trang quản lý', 'К управлению'],
  backToList: ['목록으로', 'Back', 'Quay lại', 'Назад'],
  fieldSaveBtn: ['저장', 'Save', 'Lưu', 'Сохранить'],
  hubBasicTitle: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основная информация'],
  hubBasicDesc: [
    '업체명·카테고리·연락처·홈페이지·소개·위치·대표이미지',
    'Name, category, contact, homepage, about, location, cover photo',
    'Tên, ngành, liên hệ, trang chủ, giới thiệu, vị trí, ảnh bìa',
    'Название, категория, контакты, сайт, описание, адрес, обложка',
  ],
  hubJobsBasicDesc: [
    '회사명·연락처·소개·위치·대표 이미지',
    'Company name, contact, about, location, cover photo',
    'Tên công ty, liên hệ, giới thiệu, vị trí, ảnh bìa',
    'Название компании, контакты, описание, адрес, обложка',
  ],
  hubChatTitle: ['채팅 설정', 'Chat settings', 'Cài đặt trò chuyện', 'Настройки чата'],
  hubChatDesc: [
    '채팅 사용·영업시간·안내 메시지',
    'Chat on/off, hours, auto-reply messages',
    'Bật/tắt chat, giờ hoạt động, tin nhắn tự động',
    'Вкл/выкл чата, часы работы, авто-сообщения',
  ],
  hubCatalogTitle: ['매장 소개', 'Store details', 'Giới thiệu cửa hàng', 'О магазине'],
  hubCatalogDesc: [
    '사진·서비스범위·메뉴 등록·세부 카테고리',
    'Photos, service area, menu, subcategories',
    'Ảnh, phạm vi dịch vụ, thực đơn, danh mục con',
    'Фото, зона обслуживания, меню, подкатегории',
  ],
  hubCatalogTitleService: ['매장 소개', 'Store details', 'Giới thiệu cửa hàng', 'О магазине'],
  hubCatalogDescService: [
    '사진·서비스 범위·세부 업종',
    'Photos, service area, subcategories',
    'Ảnh, phạm vi dịch vụ, danh mục con',
    'Фото, зона обслуживания, подкатегории',
  ],
  sectionCategoryDetail: ['세부 카테고리', 'Subcategories & tags', 'Danh mục con & thẻ', 'Подкатегории и теги'],
  sectionStoreGallery: ['매장·메뉴 사진', 'Store & menu photos', 'Ảnh cửa hàng & thực đơn', 'Фото магазина и меню'],
  chatEnabledLabel: ['채팅 사용', 'Enable chat', 'Bật trò chuyện', 'Включить чат'],
  chatEnabledDesc: [
    '꺼두면 고객이 채팅으로 문의할 수 없어요',
    "When off, customers can't message you",
    'Tắt thì khách không thể nhắn tin',
    'Если выключено, клиенты не смогут писать в чат',
  ],
  chatHoursLabel: ['채팅 상담 가능 시간', 'Chat availability hours', 'Giờ tư vấn trò chuyện', 'Часы доступности чата'],
  chatHoursRowSame: ['영업시간과 동일', 'Same as business hours', 'Giống giờ hoạt động', 'Как часы работы'],
  chatHoursSameLabel: [
    '영업시간과 동일하게 사용',
    'Use business hours for chat',
    'Dùng chung giờ hoạt động',
    'Использовать часы работы для чата',
  ],
  chatHoursSameDesc: [
    '꺼두면 채팅 상담 가능 시간을 따로 정할 수 있어요',
    'Turn off to set separate chat hours',
    'Tắt để đặt giờ trò chuyện riêng',
    'Отключите, чтобы задать отдельные часы чата',
  ],
  chatHoursSameHint: [
    '지금은 매장 영업시간과 동일하게 적용되고 있어요.',
    "Chat hours currently match your business hours.",
    'Giờ trò chuyện hiện đang giống với giờ hoạt động cửa hàng.',
    'Часы чата сейчас совпадают с часами работы магазина.',
  ],
  chatOfflineLabel: ['채팅 불가능 안내 메시지', 'Offline auto-reply', 'Tin nhắn ngoài giờ', 'Сообщение вне сети'],
  chatMessageDefault: ['기본 메시지 사용', 'Using default message', 'Dùng tin nhắn mặc định', 'Используется сообщение по умолчанию'],
  chatMessageCustom: ['직접 입력됨', 'Custom message', 'Đã tùy chỉnh', 'Настроено вручную'],
  chatOfflinePlaceholder: [
    '채팅이 불가능할 때 표시할 메시지를 입력하세요',
    'Message shown when chat is unavailable',
    'Nhập tin nhắn hiển thị khi không thể trò chuyện',
    'Введите сообщение, когда чат недоступен',
  ],
  chatOfflineHint: [
    '운영시간 외에 문의한 고객에게 자동으로 전송돼요',
    'Sent automatically outside business hours',
    'Tự động gửi cho khách ngoài giờ hoạt động',
    'Отправляется автоматически вне рабочего времени',
  ],
  chatWelcomeLabel: ['채팅 안내 메시지', 'Welcome message', 'Tin nhắn chào mừng', 'Приветственное сообщение'],
  chatWelcomeOn: ['전송 중', 'On', 'Đang bật', 'Включено'],
  chatWelcomeOff: ['사용 안 함', 'Off', 'Tắt', 'Выключено'],
  chatWelcomeSendLabel: ['채팅 안내 메시지 전송', 'Send welcome message', 'Gửi tin nhắn chào mừng', 'Отправлять приветствие'],
  chatWelcomeBaseHint: [
    '처음 채팅을 시작한 고객에게 자동으로 보내는 인사말이에요. 필요하면 아래에 내용을 추가하세요.',
    "Sent automatically to first-time chatters. Add extra text below if needed.",
    'Tự động gửi cho khách nhắn tin lần đầu. Thêm nội dung bên dưới nếu cần.',
    'Отправляется автоматически новым собеседникам. При необходимости добавьте текст ниже.',
  ],
  chatWelcomePlaceholder: [
    '기본 안내 메시지에 추가할 내용을 입력하세요 (선택)',
    'Add extra content to the default message (optional)',
    'Thêm nội dung vào tin nhắn mặc định (tùy chọn)',
    'Добавьте текст к сообщению по умолчанию (необязательно)',
  ],
  sectionBasic: ['기본 정보', 'Basics', 'Thông tin cơ bản', 'Основное'],
  sectionDesc: ['업체 소개', 'About', 'Giới thiệu', 'О компании'],
  sectionLocation: ['위치', 'Location', 'Vị trí', 'Местоположение'],
  sectionCatalog: ['상품 등록', 'Listings', 'Sản phẩm', 'Товары'],
  sectionCover: ['대표 이미지', 'Cover image', 'Ảnh bìa', 'Обложка'],
  sectionScope: ['서비스 범위', 'Service area', 'Phạm vi dịch vụ', 'Зона обслуживания'],
  placeholderName: ['업체명', 'Business name', 'Tên cửa hàng', 'Название'],
  contactLabel: ['업체 연락처', 'Business phone', 'SĐT cửa hàng', 'Телефон бизнеса'],
  contactHint: [
    '고객·배달원이 주문 중 연락할 수 있는 번호예요. 공개 프로필에는 노출되지 않아요.',
    'Customers and riders can reach you at this number during an order. Not shown on your public profile.',
    'Khách & tài xế có thể liên hệ số này khi có đơn. Không hiển thị công khai.',
    'Клиенты и курьеры смогут связаться по этому номеру во время заказа. Не отображается публично.',
  ],
  contactRequired: [
    '업체 연락처를 입력해 주세요',
    'Please enter a business phone number',
    'Vui lòng nhập SĐT cửa hàng',
    'Введите телефон бизнеса',
  ],
  categoryLine: ['대분류: {emoji} {label}', 'Category: {emoji} {label}', 'Ngành: {emoji} {label}', 'Категория: {emoji} {label}'],
  rowNameLabel: ['업체명', 'Business name', 'Tên cửa hàng', 'Название'],
  kakaoRowLabel: ['업체 홈페이지', 'Business homepage', 'Trang chủ doanh nghiệp', 'Сайт компании'],
  kakaoRowEmpty: ['연결 안 됨', 'Not connected', 'Chưa liên kết', 'Не подключено'],
  categoryRowLabel: ['카테고리', 'Category', 'Ngành', 'Категория'],
  hubSubHint: [
    '허브 업종 (복수 선택) — 유저가 업종별로 필터링해서 먼저 찾습니다',
    'Hub subcategories (multi) — users browse and filter by these first',
    'Ngành phụ (nhiều) — người dùng lọc theo ngành để tìm trước',
    'Подкатегории — по ним пользователи сначала фильтруют поиск',
  ],
  foodBizTypeHint: [
    '음식점·카페·마트 중 하나만 선택하세요 (대표 업종)',
    'Choose exactly one: restaurant, cafe, or mart',
    'Chọn đúng một: nhà hàng, quán cà phê hoặc siêu thị',
    'Выберите одно: ресторан, кафе или магазин',
  ],
  foodBizTypeRequired: [
    '음식점·카페·마트 중 하나를 선택해 주세요',
    'Please choose restaurant, cafe, or mart',
    'Vui lòng chọn nhà hàng, quán cà phê hoặc siêu thị',
    'Выберите ресторан, кафе или магазин',
  ],
  primarySubHint: [
    '먼저 누른 업종이 대표 업종입니다 (세부 종류는 대표 업종 기준)',
    'First selected subcategory is primary (tags follow primary).',
    'Ngành đầu tiên là đại diện (thẻ theo ngành đó).',
    'Первая подкатегория — основная (теги по ней).',
  ],
  tagsHint: [
    '제공 태그 (최대 8개) — 허브 필터 + 검색에 사용됩니다',
    'Tags (max 8) — used for hub filters & search',
    'Thẻ (tối đa 8) — dùng cho bộ lọc & tìm kiếm',
    'Теги (до 8) — для фильтров и поиска',
  ],
  serviceLangHint: ['서비스 언어', 'Service languages', 'Ngôn ngữ phục vụ', 'Языки обслуживания'],
  addLanguagesBtn: ['+ 서비스 언어 추가 (선택)', '+ Add service languages (optional)', '+ Thêm ngôn ngữ phục vụ (tùy chọn)', '+ Добавить языки обслуживания (необязательно)'],
  serviceLangRowLabel: ['서비스 언어', 'Service languages', 'Ngôn ngữ phục vụ', 'Языки обслуживания'],
  serviceLangRowCount: ['{n}개 언어', '{n} languages', '{n} ngôn ngữ', '{n} языков'],
  serviceLangRowEmpty: ['설정 안 됨 (선택)', 'Not set (optional)', 'Chưa đặt (tùy chọn)', 'Не задано (необязательно)'],
  subcategoryRowCount: ['{n}개 선택됨', '{n} selected', 'Đã chọn {n}', 'Выбрано: {n}'],
  subcategoryRowEmpty: ['선택 안 됨', 'Not selected', 'Chưa chọn', 'Не выбрано'],
  foodMenuCategoryRow: ['음식배달 대분류', 'Delivery category', 'Danh mục giao đồ ăn', 'Категория доставки'],
  foodMenuCategoryRowEmpty: ['선택 안 됨', 'Not selected', 'Chưa chọn', 'Не выбрано'],
  foodMenuCategoryHint: [
    '허브 상단 탭(치킨/한식/피자 등)에서 우리 업체가 어디에 노출될지 하나만 골라주세요.',
    'Pick one category — this decides which top tab on the hub (Chicken, Korean, Pizza, etc.) shows your business.',
    'Chọn một danh mục — quyết định tab nào trên hub (Gà rán, Hàn Quốc, Pizza,...) sẽ hiển thị cửa hàng của bạn.',
    'Выберите одну категорию — она определяет, на какой вкладке хаба (Курица, Корейская, Пицца и т.д.) покажется ваш бизнес.',
  ],
  deliveryOrderRow: ['최소주문·예상시간', 'Min order & ETA', 'Đơn tối thiểu & thời gian', 'Мин. заказ и время'],
  deliveryOrderRowEmpty: ['설정 안 됨', 'Not set', 'Chưa đặt', 'Не задано'],
  deliveryOrderHint: [
    '허브 메뉴 카드에 최소주문금액과 예상 조리시간(분)이 표시됩니다. 비우면 카드에서 숨깁니다.',
    'Shown on hub menu cards. Leave blank to hide those fields.',
    'Hiển thị trên thẻ món ở hub. Để trống sẽ ẩn.',
    'Отображается на карточках в хабе. Пустое поле скрывается.',
  ],
  attributesRowSet: ['설정됨', 'Set', 'Đã đặt', 'Задано'],
  attributesRowEmpty: ['설정 안 됨', 'Not set', 'Chưa đặt', 'Не задано'],
  descRowLabel: ['소개 메시지', 'Intro message', 'Tin nhắn giới thiệu', 'Приветственное сообщение'],
  descPlaceholder: [
    '업체를 소개해주세요 (한 줄도 OK)',
    'Describe your business (even one line)',
    'Giới thiệu cửa hàng (một dòng cũng được)',
    'Расскажите о бизнесе (хоть одна строка)',
  ],
  descAiHint: [
    '✨ 저장 후 AI가 자동으로 다국어 번역해요',
    '✨ AI translates to multiple languages after save',
    '✨ AI dịch đa ngôn ngữ sau khi lưu',
    '✨ AI переведёт на несколько языков после сохранения',
  ],
  translationComplete: ['번역 완료', 'Translation complete', 'Đã dịch xong', 'Перевод готов'],
  translationPending: ['번역 상태: 대기 중', 'Translation: pending', 'Dịch: đang chờ', 'Перевод: ожидание'],
  addressRowLabel: ['주소', 'Address', 'Địa chỉ', 'Адрес'],
  addressPlaceholder: [
    '주소 (예: 다낭 미케비치 ...)',
    'Address (e.g. My Khe Beach, Da Nang…)',
    'Địa chỉ (vd: bãi Mỹ Khê, Đà Nẵng…)',
    'Адрес (напр. пляж Ми Кхе, Дананг…)',
  ],
  latPlaceholder: ['위도 (16.xxxx)', 'Latitude (16.xxxx)', 'Vĩ độ (16.xxxx)', 'Широта (16.xxxx)'],
  lngPlaceholder: ['경도 (108.xxxx)', 'Longitude (108.xxxx)', 'Kinh độ (108.xxxx)', 'Долгота (108.xxxx)'],
  mapPinSoon: [
    '📍 나중에 지도 핀으로 교체 예정',
    '📍 Map pin picker coming soon',
    '📍 Chọn trên bản đồ sắp có',
    '📍 Выбор на карте скоро',
  ],
  priceRowEmpty: ['가격 미설정', 'Price not set', 'Chưa đặt giá', 'Цена не указана'],
  filterAttrsHint: [
    '유저가 필터로 찾을 수 있는 조건을 선택하세요',
    'Pick filters customers can search by',
    'Chọn bộ lọc khách có thể tìm',
    'Выберите фильтры для поиска',
  ],
  attrEmpty: [
    '이 업종에 등록된 필터 옵션이 아직 없어요',
    'No filter options registered for this category yet',
    'Ngành này chưa có bộ lọc nào',
    'Для этой категории пока нет фильтров',
  ],
  attrShowMore: ['+ 더보기 ({n}개)', '+ Show more ({n})', '+ Xem thêm ({n})', '+ Ещё ({n})'],
  attrShowLess: ['접기 ▲', 'Show less ▲', 'Thu gọn ▲', 'Свернуть ▲'],
  kakaoLabel: ['업체 홈페이지 링크', 'Business homepage link', 'Link trang chủ doanh nghiệp', 'Ссылка на сайт компании'],
  kakaoPlaceholder: ['https://... (홈페이지, 카카오톡 채널 등)', 'https://... (website, KakaoTalk channel, etc.)', 'https://... (trang chủ, kênh KakaoTalk...)', 'https://... (сайт, канал KakaoTalk и т.д.)'],
  kakaoHint: [
    '홈페이지나 카카오톡 채널 링크가 있다면 고객 프로필에 버튼으로 노출돼요 (선택)',
    'If you have a website or KakaoTalk channel, it shows as a button on your public profile (optional)',
    'Nếu có trang chủ hoặc kênh KakaoTalk, nút sẽ hiện trên hồ sơ công khai (tùy chọn)',
    'Если есть сайт или канал KakaoTalk, кнопка появится в публичном профиле (необязательно)',
  ],
  mapPickHint: [
    '주소를 입력하면 자동으로 위치를 찾아요. 정확하지 않으면 지도를 눌러 핀을 옮겨주세요.',
    "We'll find the location from your address automatically. Tap the map to fine-tune the pin.",
    'Vị trí sẽ được tìm tự động theo địa chỉ. Chạm bản đồ để chỉnh lại ghim nếu cần.',
    'Мы найдём место по адресу автоматически. Коснитесь карты, чтобы поправить метку.',
  ],
  mapSearchBtn: ['주소로 찾기', 'Find on map', 'Tìm trên bản đồ', 'Найти на карте'],
  mapManualToggle: ['위경도 직접 입력', 'Enter coordinates manually', 'Nhập tọa độ thủ công', 'Ввести координаты вручную'],
  mapNoResult: [
    '주소를 찾지 못했어요. 지도를 눌러 직접 위치를 선택해주세요.',
    "Couldn't find that address. Tap the map to set the location manually.",
    'Không tìm thấy địa chỉ. Hãy chạm bản đồ để chọn vị trí.',
    'Не удалось найти адрес. Коснитесь карты, чтобы указать место вручную.',
  ],
  mapOpenHelp: [
    '지도에서 위치 확인',
    'Check on map',
    'Kiểm tra trên bản đồ',
    'Проверить на карте',
  ],
  mapSearching: ['찾는 중…', 'Searching…', 'Đang tìm…', 'Поиск…'],

  catalogHint: [
    '상품은 {tab} 탭에서 등록해요. 프로필에 적은 내용은 고객에게 상품으로 노출되지 않습니다.',
    "Register items in the {tab} tab. Text entered in this profile section isn't shown to customers as a listing.",
    'Đăng sản phẩm ở tab {tab}. Nội dung trong hồ sơ này không hiển thị cho khách như một sản phẩm.',
    'Товары регистрируются во вкладке {tab}. Текст в этом разделе профиля не отображается клиентам как товар.',
  ],
  goCatalogTab: ['{tab} 탭으로 이동', 'Go to {tab} tab', 'Mở tab {tab}', 'Перейти во вкладку {tab}'],
  addCatalog: ['+ 상품 등록', '+ Add listing', '+ Đăng sản phẩm', '+ Добавить товар'],
  coverRowSet: ['등록됨', 'Uploaded', 'Đã tải lên', 'Загружено'],
  coverRowEmpty: ['미등록', 'Not set', 'Chưa có', 'Не загружено'],
  coverHint: [
    '로고·간판·외관 1장 — 목록 썸네일과 상세 상단에 표시됩니다',
    'One logo, sign or exterior shot — list thumbnail & detail header',
    '1 ảnh logo/biển hiệu — thumbnail & đầu trang chi tiết',
    '1 фото логотипа/вывески — миниатюра и шапка',
  ],
  addCover: ['+ 대표 이미지', '+ Cover image', '+ Ảnh bìa', '+ Обложка'],
  coverUploadHint: [
    'JPEG·PNG·WebP. 업로드 시 자동 압축·EXIF 제거됩니다.',
    'JPEG·PNG·WebP. Auto-compressed & EXIF stripped on upload.',
    'JPEG·PNG·WebP. Tự nén & xóa EXIF khi tải lên.',
    'JPEG·PNG·WebP. Сжатие и удаление EXIF при загрузке.',
  ],
  galleryRowCount: ['{n}장', '{n} photos', '{n} ảnh', '{n} фото'],
  galleryRowEmpty: ['미등록', 'Not set', 'Chưa có', 'Не загружено'],
  galleryHint: [
    '사진 여러 장 (선택) — 상세 페이지 갤러리에 표시됩니다',
    'More photos (optional) — shown in detail gallery',
    'Nhiều ảnh (tùy chọn) — gallery trang chi tiết',
    'Доп. фото (необяз.) — галерея на странице',
  ],
  addGallery: ['+ 사진 추가 ({n}/9)', '+ Add photo ({n}/9)', '+ Thêm ảnh ({n}/9)', '+ Фото ({n}/9)'],
  galleryMaxHint: [
    '최대 9장까지 등록할 수 있어요.',
    'Up to 9 photos.',
    'Tối đa 9 ảnh.',
    'До 9 фото.',
  ],
  scopeCity: ['도시', 'City', 'Thành phố', 'Город'],
  scopeCountry: ['국가', 'Country', 'Quốc gia', 'Страна'],
  scopeGlobal: ['글로벌', 'Global', 'Toàn cầu', 'Глобально'],
  hoursRowSet: ['설정됨', 'Set', 'Đã đặt', 'Настроено'],
  hoursRowUnset: ['미설정', 'Not set', 'Chưa đặt', 'Не настроено'],
  scheduleExTitle: [
    '특정 날짜 예외 (공휴일 등)',
    'Date-specific exceptions (holidays etc.)',
    'Ngoại lệ theo ngày (lễ, Tết...)',
    'Исключения по датам (праздники и т.д.)',
  ],
  scheduleExHint: [
    '공휴일처럼 특정 날짜만 영업시간이 다르거나 가격이 오르는 경우 등록해요. 등록 안 하면 평소 영업시간이 적용돼요.',
    'Add a date when hours differ or prices rise (e.g. a holiday). Without one, regular hours apply.',
    'Thêm ngày có giờ mở cửa khác hoặc giá tăng (VD: ngày lễ). Nếu không thêm, áp dụng giờ thường.',
    'Добавьте дату с другими часами или наценкой (напр. праздник). Иначе действует обычный график.',
  ],
  scheduleExDateRequired: ['날짜를 선택해 주세요.', 'Please pick a date.', 'Vui lòng chọn ngày.', 'Пожалуйста, выберите дату.'],
  scheduleExClosed: ['휴무', 'Closed', 'Nghỉ', 'Закрыто'],
  scheduleExSaved: ['저장했어요.', 'Saved.', 'Đã lưu.', 'Сохранено.'],
  scheduleExSaveFailed: ['저장에 실패했어요.', 'Failed to save.', 'Lưu thất bại.', 'Не удалось сохранить.'],
  scheduleExSurchargePlaceholder: ['할증 %(선택)', 'Surcharge % (optional)', '% phụ thu (tùy chọn)', 'Наценка % (необязательно)'],
  scheduleExNotePlaceholder: ['메모 (예: 설날 연휴)', 'Note (e.g. Lunar New Year)', 'Ghi chú (VD: Tết)', 'Заметка (напр. Новый год)'],
  scheduleExAdd: ['추가', 'Add', 'Thêm', 'Добавить'],
  scheduleExSaving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  scheduleExDelete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  serviceRadiusLabel: ['매장 이용 반경', 'Service radius', 'Bán kính phục vụ', 'Радиус обслуживания'],
  serviceRadiusHint: [
    '고객이 매장을 이용할 것으로 보는 거리예요. 배달 반경은 메뉴관리 탭에서 따로 설정해요.',
    'How far customers are expected to travel for in-store visits. Set delivery radius separately in the menu tab.',
    'Khoảng cách khách hàng có thể di chuyển để đến trực tiếp. Bán kính giao hàng cài đặt riêng ở tab menu.',
    'Расстояние, на которое клиенты готовы ехать для визита. Радиус доставки настраивается отдельно во вкладке меню.',
  ],
  serviceCountries: ['서비스 국가', 'Service countries', 'Quốc gia phục vụ', 'Страны обслуживания'],
  pickCitiesHint: [
    '서비스 국가를 선택하면 나라별로 운영 도시를 고를 수 있어요',
    'Select countries, then pick operating cities per country',
    'Chọn quốc gia rồi chọn thành phố hoạt động',
    'Выберите страны, затем города',
  ],
  saving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  saveBtn: ['저장하기', 'Save', 'Lưu', 'Сохранить'],
};

const profileGuide = {
  businessFallback: ['업체', 'Business', 'Cửa hàng', 'Бизнес'],
  scoreLine: [
    '프로필 {score}% · 아래에서 상세 정보를 채워 주세요',
    'Profile {score}% · Complete details below',
    'Hồ sơ {score}% · Điền chi tiết bên dưới',
    'Профиль {score}% · Заполните ниже',
  ],
  leadMulti: [
    '「{name}」만의 정보를 아래에서 수정해요. 업체가 {count}개면 각 업체마다 따로 저장됩니다.',
    'Edit info for 「{name}」 below. With {count} businesses, each saves separately.',
    'Sửa thông tin 「{name}」 bên dưới. {count} cửa hàng — lưu riêng từng cái.',
    'Редактируйте 「{name}」 ниже. При {count} бизнесах — отдельное сохранение.',
  ],
  leadWithCatalog: [
    '30초 간편등록으로 시작했어요. 이 화면에서 소개·사진·영업시간을 채우고, 상품은 아래 「상품 등록」 또는 홈 ⊕ 버튼에서 추가하세요.',
    'Quick registration done. Fill intro, photos & hours here; add listings via 「Add listing」 or the home ⊕ button.',
    'Đăng ký nhanh xong. Điền giới thiệu, ảnh & giờ; thêm sản phẩm qua 「Đăng sản phẩm」 hoặc nút ⊕ ở trang chủ.',
    'Быстрая регистрация. Заполните описание, фото и часы; товары — через 「Добавить」 или кнопку ⊕ на главной.',
  ],
  leadNoCatalog: [
    '30초 간편등록으로 시작했어요. 이 화면에서 소개·사진·영업시간을 채우면 검색 노출이 올라갑니다.',
    'Quick registration done. Fill intro, photos & hours to improve search visibility.',
    'Đăng ký nhanh. Điền giới thiệu, ảnh & giờ để tăng hiển thị tìm kiếm.',
    'Быстрая регистрация. Заполните профиль для лучшей выдачи.',
  ],
  stepIntro: ['업체 소개·사진 — 검색·피드 노출', 'Intro & photos — search & feed', 'Giới thiệu & ảnh — tìm kiếm', 'Описание и фото — поиск'],
  stepHours: ['영업시간·위치 — 「영업중」「거리순」 필터', 'Hours & location — Open now & distance filters', 'Giờ & vị trí — bộ lọc đang mở', 'Часы и адрес — фильтры'],
  stepCatalog: [
    '{tab} — 상품 탭에서 등록 (홈 ⊕ 버튼과 동일)',
    '{tab} — register in the listings tab (same as the home ⊕ button)',
    '{tab} — đăng ở tab sản phẩm (như nút ⊕ ở trang chủ)',
    '{tab} — во вкладке товаров (как кнопка ⊕ на главной)',
  ],
  stepChat: ['채팅·문의 — 고객 연결', 'Chat & inquiries — connect customers', 'Chat & liên hệ — kết nối khách', 'Чат — связь с клиентами'],
  goTabBtn: ['{tab} 탭으로', 'Go to {tab}', 'Mở tab {tab}', 'К вкладке {tab}'],
  addListingBtn: ['+ 상품 등록', '+ Add listing', '+ Đăng sản phẩm', '+ Добавить товар'],
  multiSwitchHint: [
    '다른 업체를 수정하려면 상단 「{name} ▼」에서 업체를 바꾸거나 「+ 업체 추가」를 눌러 주세요.',
    'Switch business via 「{name} ▼」 or tap 「+ Add business」.',
    'Đổi cửa hàng qua 「{name} ▼」 hoặc 「+ Thêm cửa hàng」.',
    'Смените бизнес через 「{name} ▼」 или 「+ Добавить」.',
  ],
  multiAddHint: [
    '다른 업종 업체를 더 등록하려면 상단 「+ 업체 추가」를 눌러 주세요.',
    'Add another business via 「+ Add business」 at the top.',
    'Thêm cửa hàng khác qua 「+ Thêm cửa hàng」.',
    'Добавьте ещё бизнес через 「+ Добавить」.',
  ],
};

const manageTab = {
  selectBusiness: ['업체를 선택해 주세요.', 'Select a business.', 'Chọn cửa hàng.', 'Выберите бизнес.'],
  title: ['비즈니스 관리', 'Business settings', 'Quản lý doanh nghiệp', 'Управление бизнесом'],
};

const departureGroups = {
  dateTbd: ['미정', 'TBD', 'Chưa xác định', 'Не указано'],
  empty: ['출발 예정인 확정 예약이 없어요', 'No confirmed departures yet', 'Chưa có chuyến khởi hành', 'Нет подтверждённых выездов'],
  groupTitle: ['{date} 출발 ({count}건)', 'Departure {date} ({count} bookings)', 'Khởi hành {date} ({count} đặt)', 'Выезд {date} ({count} броней)'],
  metaLine: ['총 {people}명 · {insurance}', 'Total {people} guests · {insurance}', 'Tổng {people} khách · {insurance}', 'Всего {people} · {insurance}'],
  primaryMissing: ['대표 미입력', 'Primary not entered', 'Chưa nhập đại diện', 'Нет основного'],
  primaryLabel: ['{name} (대표)', '{name} (primary)', '{name} (chính)', '{name} (основной)'],
  companionFallback: ['동반', 'Companion', 'Đi cùng', 'Спутник'],
  packageFallback: ['패키지', 'Package', 'Gói', 'Пакет'],
  peopleLine: [
    '{n}명 (예약자 1 + 동반 {companions})',
    '{n} guests (1 booker + {companions} companions)',
    '{n} khách (1 người đặt + {companions} đi cùng)',
    '{n} гостей (1 + {companions} спутников)',
  ],
  insurancePrefix: ['보험: {status}', 'Insurance: {status}', 'Bảo hiểm: {status}', 'Страховка: {status}'],
  bookingDetail: ['예약 상세', 'Booking details', 'Chi tiết đặt chỗ', 'Детали брони'],
  copyAll: ['전체 명단 복사', 'Copy full list', 'Sao chép toàn bộ', 'Копировать весь список'],
  excelDownload: ['엑셀 다운로드', 'Download Excel', 'Tải Excel', 'Скачать Excel'],
};

const staffAssign = {
  channelApp: ['앱 푸시', 'App push', 'Thông báo app', 'Push в приложении'],
  channelKakao: ['카카오톡', 'KakaoTalk', 'KakaoTalk', 'KakaoTalk'],
  channelZalo: ['잘로', 'Zalo', 'Zalo', 'Zalo'],
  channelWhatsapp: ['WhatsApp', 'WhatsApp', 'WhatsApp', 'WhatsApp'],
  roleGuide: ['가이드', 'Guide', 'Hướng dẫn viên', 'Гид'],
  roleLocalGuide: ['로컬 가이드', 'Local guide', 'Hướng dẫn địa phương', 'Местный гид'],
  roleDriver: ['차량 기사', 'Driver', 'Tài xế', 'Водитель'],
  namePlaceholder: ['{role} 이름', '{role} name', 'Tên {role}', 'Имя: {role}'],
  contactPlaceholder: ['연락처', 'Phone', 'Điện thoại', 'Телефон'],
  kakaoPlaceholder: ['카카오톡 ID 또는 링크', 'KakaoTalk ID or link', 'ID/link KakaoTalk', 'KakaoTalk ID или ссылка'],
  vehicleNo: ['차량번호', 'Plate no.', 'Biển số', 'Номер авто'],
  vehicleType: ['차종', 'Vehicle type', 'Loại xe', 'Тип авто'],
  sendChannel: ['발송 채널', 'Send channel', 'Kênh gửi', 'Канал отправки'],
  appUserLink: ['앱 사용자 연결 (선택)', 'Link app user (optional)', 'Liên kết user app (tùy chọn)', 'Привязка пользователя (необяз.)'],
  linked: ['연결됨', 'Linked', 'Đã liên kết', 'Привязано'],
  unlink: ['해제', 'Unlink', 'Gỡ', 'Отвязать'],
  searchUser: ['사용자 검색', 'Search user', 'Tìm user', 'Поиск пользователя'],
  copyMessage: ['메시지 복사', 'Copy message', 'Sao chép tin nhắn', 'Копировать сообщение'],
  openKakao: ['카카오톡으로 열기', 'Open KakaoTalk', 'Mở KakaoTalk', 'Открыть KakaoTalk'],
  openZalo: ['잘로로 열기', 'Open Zalo', 'Mở Zalo', 'Открыть Zalo'],
  searchModalTitle: ['{role} — 앱 사용자 검색', '{role} — search app user', '{role} — tìm user app', '{role} — поиск пользователя'],
  copySuccess: ['복사됨!', 'Copied!', 'Đã sao chép!', 'Скопировано!'],
  copyFail: ['복사에 실패했어요', 'Could not copy', 'Không sao chép được', 'Не удалось скопировать'],
};

const insurancePanel = {
  title: ['보험 가입 상태', 'Insurance status', 'Trạng thái bảo hiểm', 'Статус страховки'],
  companyLabel: ['보험사명', 'Insurer', 'Công ty bảo hiểm', 'Страховая'],
  policyLabel: ['증권번호', 'Policy no.', 'Số hợp đồng', '№ полиса'],
  notesLabel: ['비고', 'Notes', 'Ghi chú', 'Заметки'],
  actionSubmitted: ['📤 제출 완료로 변경', '📤 Mark submitted', '📤 Đánh dấu đã nộp', '📤 Отправлено'],
  actionCompleted: ['✅ 가입 완료로 변경', '✅ Mark completed', '✅ Hoàn tất', '✅ Оформлено'],
  actionFailed: ['❌ 실패로 변경', '❌ Mark failed', '❌ Thất bại', '❌ Ошибка'],
  actionReview: ['⚠️ 재확인 필요로 변경', '⚠️ Needs review', '⚠️ Cần xem lại', '⚠️ На проверке'],
  saving: ['저장 중…', 'Saving…', 'Đang lưu…', 'Сохранение…'],
  saveBtn: ['저장하기', 'Save', 'Lưu', 'Сохранить'],
};

const insuranceStatus = {
  pending: ['보험 미제출', 'Not submitted', 'Chưa nộp', 'Не подано'],
  submitted: ['보험사 제출 완료', 'Submitted to insurer', 'Đã nộp công ty BH', 'Отправлено'],
  completed: ['보험 가입 완료', 'Insurance active', 'Đã mua BH', 'Оформлено'],
  failed: ['가입 실패', 'Failed', 'Thất bại', 'Ошибка'],
  needs_review: ['재확인 필요', 'Needs review', 'Cần xem lại', 'На проверке'],
  pendingUser: ['여행자보험 가입을 준비 중이에요', 'Travel insurance is being prepared', 'Đang chuẩn bị bảo hiểm', 'Готовим страховку'],
  submittedUser: ['여행자보험 가입이 진행 중이에요', 'Travel insurance in progress', 'Đang xử lý bảo hiểm', 'Страховка оформляется'],
  completedUser: ['여행자보험 가입 완료', 'Travel insurance active', 'Đã mua bảo hiểm', 'Страховка оформлена'],
  failedUser: [
    '보험 가입 중 문제가 생겼어요. 여행사에 문의해주세요.',
    'There was a problem. Please contact the agency.',
    'Có lỗi. Liên hệ đại lý.',
    'Ошибка. Свяжитесь с агентством.',
  ],
  needsReviewUser: ['보험 가입 정보를 다시 확인 중이에요', 'Reviewing insurance details', 'Đang xem lại thông tin BH', 'Проверяем данные'],
  summaryEmpty: ['보험: —', 'Insurance: —', 'Bảo hiểm: —', 'Страховка: —'],
  summaryAllDone: ['보험: ✅ 완료', 'Insurance: ✅ done', 'Bảo hiểm: ✅ xong', 'Страховка: ✅ готово'],
  summaryAllPending: ['보험: ⏳ {n}건', 'Insurance: ⏳ {n}', 'Bảo hiểm: ⏳ {n}', 'Страховка: ⏳ {n}'],
  summaryMixed: ['보험: ✅ {done} / ⏳ {pending}', 'Insurance: ✅ {done} / ⏳ {pending}', 'Bảo hiểm: ✅ {done} / ⏳ {pending}', 'Страховка: ✅ {done} / ⏳ {pending}'],
};

const manifest = {
  passportExpiryWarn: [
    '{name}님 여권이 출발일 기준 {months}개월 후 만료됩니다.',
    "{name}'s passport expires {months} months after departure.",
    'Hộ chiếu {name} hết hạn sau {months} tháng kể từ ngày đi.',
    'Паспорт {name} истекает через {months} мес. после выезда.',
  ],
  rolePrimaryBooker: ['대표예약자', 'Primary booker', 'Người đặt chính', 'Основной'],
  departureDayTitle: [
    '[{tour}] 전체 여행자 명단',
    '[{tour}] Full traveler list',
    '[{tour}] Danh sách du khách',
    '[{tour}] Полный список',
  ],
  departureDate: ['출발일: {date}', 'Departure: {date}', 'Ngày đi: {date}', 'Выезд: {date}'],
  totalPeople: ['총 인원: {n}명', 'Total: {n} guests', 'Tổng: {n} khách', 'Всего: {n} гостей'],
  bookingHeader: ['== 예약 {n} ==', '== Booking {n} ==', '== Đặt chỗ {n} ==', '== Бронь {n} =='],
  genderMale: ['남', 'M', 'Nam', 'М'],
  genderFemale: ['여', 'F', 'Nữ', 'Ж'],
  passportExpiryLabel: ['만료', 'Expiry', 'Hết hạn', 'Срок'],
  ssnLabel: ['주민번호', 'SSN', 'SSN', 'SSN'],
  allergyLabel: ['알레르기', 'Allergy', 'Dị ứng', 'Аллергия'],
  requestsLabel: ['요청', 'Requests', 'Yêu cầu', 'Пожелания'],
};

const wallet = {
  title: ['밍고크레딧', 'Mingo Credit', 'Mingo Credit (điểm quảng cáo)', 'Mingo Credit (баллы)'],
  balanceLabel: ['보유 크레딧', 'Credit balance', 'Số dư credit', 'Баланс кредитов'],
  chargeTitle: ['충전하기', 'Top up', 'Nạp thêm', 'Пополнить'],
  chargeAmountLabel: ['충전할 크레딧 수량', 'Amount to charge', 'Số lượng credit nạp', 'Количество для пополнения'],
  chargeNotePlaceholder: [
    '입금자명 등 메모 (선택)',
    'Note, e.g. payer name (optional)',
    'Ghi chú, vd tên người chuyển (tùy chọn)',
    'Заметка, напр. имя плательщика (необязательно)',
  ],
  chargeSubmit: ['충전 요청', 'Request top-up', 'Yêu cầu nạp', 'Запросить пополнение'],
  chargeSubmitting: ['요청 중…', 'Requesting…', 'Đang gửi…', 'Отправка…'],
  chargeSuccess: [
    '충전 요청을 접수했어요. 확인 후 반영돼요.',
    'Request received. Credits will be added after review.',
    'Đã nhận yêu cầu. Credit sẽ được cộng sau khi duyệt.',
    'Запрос принят. Кредиты будут начислены после проверки.',
  ],
  chargeFail: ['충전 요청에 실패했어요.', 'Could not submit the request.', 'Gửi yêu cầu thất bại.', 'Не удалось отправить запрос.'],
  adsRowTitle: ['광고 집행', 'Ad campaigns', 'Quảng cáo', 'Рекламные кампании'],
  adsRowDesc: [
    '진행 중인 캠페인 관리',
    'Manage running campaigns',
    'Quản lý chiến dịch đang chạy',
    'Управление активными кампаниями',
  ],
  planRowTitle: ['플랜 · 요금제', 'Plan & pricing', 'Gói & bảng giá', 'Тариф и цены'],
  planRowDesc: [
    '현재 플랜 확인, 업그레이드',
    'Check plan, upgrade options',
    'Xem gói hiện tại, nâng cấp',
    'Текущий тариф, апгрейд',
  ],
  historyTitle: ['최근 내역', 'Recent history', 'Lịch sử gần đây', 'Последние операции'],
  historyEmpty: ['내역이 없어요', 'No history yet', 'Chưa có lịch sử', 'Пока нет истории'],
  requestsTitle: ['충전 신청 내역', 'Top-up requests', 'Yêu cầu nạp', 'Запросы на пополнение'],
  pendingBanner: [
    '승인 대기 중인 충전 신청이 있어요. 확인 후 크레딧이 반영돼요.',
    'You have a top-up request awaiting approval. Credits will be added once reviewed.',
    'Bạn có yêu cầu nạp đang chờ duyệt. Credit sẽ được cộng sau khi kiểm tra.',
    'У вас есть запрос на пополнение, ожидающий подтверждения. Кредиты будут начислены после проверки.',
  ],
  statusPending: ['승인 대기중', 'Pending approval', 'Đang chờ duyệt', 'Ожидает подтверждения'],
  statusApproved: ['승인됨', 'Approved', 'Đã duyệt', 'Одобрено'],
  statusRejected: ['거절됨', 'Rejected', 'Đã từ chối', 'Отклонено'],
  cardTopupToggle: ['카드로 즉시 충전', 'Top up instantly by card', 'Nạp ngay bằng thẻ', 'Пополнить картой сразу'],
  cardTopupTitle: ['카드 자동충전', 'Instant card top-up', 'Nạp tự động bằng thẻ', 'Мгновенное пополнение картой'],
  cardTopupEstimate: [
    '예상 결제금액: {amount} USD',
    'Estimated charge: {amount} USD',
    'Số tiền dự kiến: {amount} USD',
    'Примерная сумма: {amount} USD',
  ],
  cardTopupSubmit: [
    '{credits}개 · {amount} USD 결제하기',
    'Pay {amount} USD for {credits} credits',
    'Thanh toán {amount} USD cho {credits} credit',
    'Оплатить {amount} USD за {credits} кредитов',
  ],
  cardTopupSubmitting: ['결제 처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  cardTopupSuccess: [
    '카드로 크레딧이 충전됐어요!',
    'Credits added via card payment!',
    'Đã nạp credit bằng thẻ!',
    'Кредиты пополнены картой!',
  ],
  cardTopupFail: ['카드 결제에 실패했어요.', 'Card payment failed.', 'Thanh toán bằng thẻ thất bại.', 'Оплата картой не удалась.'],
  cardTopupLoading: [
    '결제 모듈을 불러오는 중이에요. 잠시 후 다시 시도해 주세요.',
    'Loading payment module. Please try again shortly.',
    'Đang tải mô-đun thanh toán. Vui lòng thử lại sau.',
    'Загрузка платёжного модуля. Повторите попытку чуть позже.',
  ],
  cardTopupUnavailable: [
    '카드 결제가 아직 준비되지 않았어요. 아래 수동 충전 요청을 이용해 주세요.',
    'Card payment is not available yet. Please use the manual top-up request below.',
    'Thanh toán bằng thẻ chưa khả dụng. Vui lòng dùng yêu cầu nạp thủ công bên dưới.',
    'Оплата картой пока недоступна. Используйте запрос на ручное пополнение ниже.',
  ],
  orDivider: ['또는', 'or', 'hoặc', 'или'],
};

const settlement = {
  monthTotalLabel: ['이번 달 정산 예정 금액', 'This month’s settlement', 'Số tiền quyết toán tháng này', 'Расчёт за этот месяц'],
  accountTitle: ['정산 계좌', 'Settlement account', 'Tài khoản quyết toán', 'Счёт для расчётов'],
  accountEmpty: ['등록된 계좌가 없어요', 'No account registered', 'Chưa đăng ký tài khoản', 'Счёт не указан'],
  accountValidation: [
    '은행명, 예금주, 계좌번호를 모두 입력해주세요',
    'Please fill in bank, holder, and account number',
    'Vui lòng nhập đầy đủ ngân hàng, chủ tài khoản và số tài khoản',
    'Заполните банк, владельца и номер счёта',
  ],
  bankNameLabel: ['은행명', 'Bank name', 'Tên ngân hàng', 'Название банка'],
  bankNamePlaceholder: ['예: 국민은행', 'e.g. Vietcombank', 'VD: Vietcombank', 'напр. Сбербанк'],
  accountHolderLabel: ['예금주', 'Account holder', 'Chủ tài khoản', 'Владелец счёта'],
  accountHolderPlaceholder: ['예금주명 입력', 'Enter holder name', 'Nhập tên chủ tài khoản', 'Введите имя владельца'],
  accountNumberLabel: ['계좌번호', 'Account number', 'Số tài khoản', 'Номер счёта'],
  accountNumberPlaceholder: ['계좌번호 입력', 'Enter account number', 'Nhập số tài khoản', 'Введите номер счёта'],
  accountHint: [
    '정산금은 매월 등록된 계좌로 입금돼요.',
    'Settlement funds are paid out to this account monthly.',
    'Tiền quyết toán được chuyển vào tài khoản này hằng tháng.',
    'Средства перечисляются на этот счёт ежемесячно.',
  ],
  saveFail: ['저장 실패', 'Could not save', 'Không lưu được', 'Не удалось сохранить'],
  saveSuccess: ['계좌 정보를 저장했어요', 'Account saved', 'Đã lưu tài khoản', 'Счёт сохранён'],
  historyTitle: ['정산 내역', 'Settlement history', 'Lịch sử quyết toán', 'История расчётов'],
  historyEmpty: ['완료된 주문이 없어요', 'No completed orders yet', 'Chưa có đơn hoàn tất', 'Пока нет завершённых заказов'],
  orderFallback: ['주문', 'Order', 'Đơn hàng', 'Заказ'],
  bookingFallback: ['예약결제', 'Booking payment', 'Thanh toán đặt chỗ', 'Оплата бронирования'],
  sourceFood: ['음식/카페', 'Food/Cafe', 'Đồ ăn/Cà phê', 'Еда/Кафе'],
  sourceBooking: ['예약', 'Booking', 'Đặt chỗ', 'Бронирование'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    dashboard: {
      manageForm: pick(manageForm, langIndex),
      profileGuide: pick(profileGuide, langIndex),
      manageTab: pick(manageTab, langIndex),
      departureGroups: pick(departureGroups, langIndex),
      staffAssign: pick(staffAssign, langIndex),
      insurancePanel: pick(insurancePanel, langIndex),
      insuranceStatus: pick(insuranceStatus, langIndex),
      manifest: pick(manifest, langIndex),
      wallet: pick(wallet, langIndex),
      settlement: pick(settlement, langIndex),
    },
  };
}

export const phaseE3Ko = buildLang(0);
export const phaseE3En = buildLang(1);
export const phaseE3Vi = buildLang(2);
export const phaseE3Ru = buildLang(3);

export const STAFF_SEND_CHANNEL_OPTIONS = [
  { value: 'app', labelKey: 'dashboard.staffAssign.channelApp', icon: 'ti-bell' },
  { value: 'kakao', labelKey: 'dashboard.staffAssign.channelKakao', icon: 'ti-brand-kako-talk' },
  { value: 'zalo', labelKey: 'dashboard.staffAssign.channelZalo', icon: 'ti-message' },
  { value: 'whatsapp', labelKey: 'dashboard.staffAssign.channelWhatsapp', icon: 'ti-brand-whatsapp' },
];

export const STAFF_ROLE_SECTIONS = [
  {
    key: 'guide',
    titleKey: 'dashboard.staffAssign.roleGuide',
    nameKey: 'guide_name',
    phoneKey: 'guide_phone',
    kakaoKey: 'guide_kakao',
    userIdKey: 'guide_user_id',
    userLabelKey: 'guide_user_label',
    channelKey: 'guide_send_channel',
    copyRole: 'guide',
    showKakao: true,
    extraFields: [],
  },
  {
    key: 'local_guide',
    titleKey: 'dashboard.staffAssign.roleLocalGuide',
    nameKey: 'local_guide_name',
    phoneKey: 'local_guide_phone',
    userIdKey: 'local_guide_user_id',
    userLabelKey: 'local_guide_user_label',
    channelKey: 'local_guide_send_channel',
    copyRole: 'local_guide',
    showKakao: false,
    extraFields: [],
  },
  {
    key: 'driver',
    titleKey: 'dashboard.staffAssign.roleDriver',
    nameKey: 'driver_name',
    phoneKey: 'driver_phone',
    userIdKey: 'driver_user_id',
    userLabelKey: 'driver_user_label',
    channelKey: 'driver_send_channel',
    copyRole: 'driver',
    showKakao: false,
    extraFields: [
      { key: 'vehicle_number', labelKey: 'dashboard.staffAssign.vehicleNo', placeholderKey: 'dashboard.staffAssign.vehicleNo' },
      { key: 'vehicle_type', labelKey: 'dashboard.staffAssign.vehicleType', placeholderKey: 'dashboard.staffAssign.vehicleType' },
    ],
  },
];

export const INSURANCE_STATUS_ACTIONS = [
  ['submitted', 'dashboard.insurancePanel.actionSubmitted'],
  ['completed', 'dashboard.insurancePanel.actionCompleted'],
  ['failed', 'dashboard.insurancePanel.actionFailed'],
  ['needs_review', 'dashboard.insurancePanel.actionReview'],
];
